import { VALIDATION_MESSAGE_CLASS_NAME } from "./ValidationMessage";

const OFFSET_Y = -20;

const determineScrollToElement = (element: Element): Element => {
  const cardElement = element.closest(".card");

  if (cardElement) {
    const cardYPosition = cardElement.getBoundingClientRect().top + window.scrollY;
    const elementYPosition = element.getBoundingClientRect().top + window.scrollY;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    const distanceToCard = elementYPosition - cardYPosition;

    if (distanceToCard < windowHeight / 2) {
      return cardElement;
    }
  }

  return element.parentElement ?? element;
};

export const scrollToFirstValidationMessage = () => {
  const validationMessages = document.getElementsByClassName(VALIDATION_MESSAGE_CLASS_NAME);

  if (validationMessages.length > 0) {
    const firstValidationMessage = validationMessages[0];

    const scrollToElement = determineScrollToElement(firstValidationMessage);

    const y = scrollToElement.getBoundingClientRect().top + window.pageYOffset + OFFSET_Y;

    window.scrollTo({ top: y, behavior: "smooth" });
  }
};
